// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"23077e91","796":"9c1f6241"}[chunkId] + ".chunk.js";
};